const React = require("react");
const PropTypes = require("prop-types");

const List = ({ children }) => <dl className="pane__list">{children}</dl>;

List.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = List;
